import { z } from 'zod'

import { FoodType } from './FoodType'

export const Food = z.object({
  id: z.string(),
  name: z.string(),
  type: FoodType
})
export type Food = z.infer<typeof Food>

export const CreateFoodDTO = z.object({
  name: z.string(),
  type: FoodType
})
export type CreateFoodDTO = z.infer<typeof CreateFoodDTO>
